// This is generated.  Alter it in blockGroups/workflowCriteriaElements/types/ShortTextCriteria.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      minLength,
      maxLength,
      pattern,
      propertyName,
      required = false,
    } = hNode;

    // we could be on an update form, or on a new form, or nested somewhere
    // We just don't know what accessContext this would be enabling, nor how it is applied on a NS/REL
    // Security Modifiers (which would disabled certain accessContext) are processed generically
    // All we know is that Whatever propertyName is on this Criteria block
    // and how it is formatted.

    // Build string schema options with validation constraints
    const stringOptions = {
      'x-dataType': 'string',
      'x-optional': !required,
      minLength,
      maxLength,
    };

    // Add pattern if provided (pattern is a standard JSON Schema field)
    if (pattern) {
      stringOptions.pattern = pattern;
    }

    // Create TypeBox string schemas for each operator
    const eqSchema = Type.Optional(
      Type.String({
        ...stringOptions,
        title: 'Test for equality',
        'x-propertyName': '_eq',
      }),
    );

    const neqSchema = Type.Optional(
      Type.String({
        ...stringOptions,
        title: 'Test for inequality',
        'x-propertyName': '_neq',
      }),
    );

    const containsSchema = Type.Optional(
      Type.String({
        ...stringOptions,
        title: 'Test property for containing specified value',
        'x-propertyName': '_contains',
      }),
    );

    const startsWithSchema = Type.Optional(
      Type.String({
        ...stringOptions,
        title: 'Test property to start with specified value',
        'x-propertyName': '_startsWith',
      }),
    );

    // Create main criteria object containing all operators
    const criteriaSchema = Type.Object(
      {
        _eq: eqSchema,
        _neq: neqSchema,
        _contains: containsSchema,
        _startsWith: startsWithSchema,
      },
      {
        'x-id': hNode.id,
        title: hNode.title,
        'x-tooltip': hNode.tooltip,
        'x-propertyName': propertyName,
        'x-dataType': 'object',
        'x-optional': !required,
        additionalProperties: false,
      },
    );

    const partialTypeDefinition = {
      [propertyName]: required ? criteriaSchema : Type.Optional(criteriaSchema),
    };

    return [{}, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'workflowCriteriaElements',
  'ShortTextCriteria',
  module.exports,
);
